import { styled } from 'ui/styles'

export const RedSpan = styled.span`
  color: ${({ theme }) => theme.palette.pink_red};
`
